const storage = {
    not_configured: 'ยังไม่ได้กำหนดผู้ให้บริการจัดเก็บข้อมูล',
    missing_parameter: 'ขาดพารามิเตอร์ {{parameter}} สำหรับผู้ให้บริการจัดเก็บข้อมูล',
    upload_error: 'อัปโหลดไฟล์ไปยังผู้ให้บริการจัดเก็บข้อมูลไม่สำเร็จ',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
